import React from "react"
import styled from "styled-components"
import { brand } from "../../brand"
import DefaultImage from "../../Components/Images/index"
import { Text } from "../../Components/Text"
import { color } from "../../Components/Theme"
import { TRIAL_COPY as C } from "../../copy/trialCopy"
import { formatTrialDate } from "../../accessState"
import Subscriptions from "../Subscriptions"

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 16px 8px;
  box-sizing: border-box;
  background-color: ${color("primary")};
`

const Card = styled.div`
  max-width: 1100px;
  width: 100%;
  padding: 24px 12px;
  border-radius: 10px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
`

// Lock screen: the owner sees the pricing table, everyone else is told to contact the owner.
export default function LockScreen({ isOwner, trial, cancelled, logout }) {
  return (
    <Wrapper data-testid="lock-screen">
      <Card>
        <DefaultImage $width={"120px"} $src={brand.logo} $objectFit="contain" />
        <Text $fontSize="heading-2" $marginTop="4">{cancelled ? C.cancelledTitle : C.lockedTitleTrial}</Text>
        <Text $fontSize="body" $marginTop="4" $marginBottom="4">
          {isOwner ? C.lockedSubtitleOwner : C.lockedSubtitleNonOwner}
        </Text>
        {trial?.deleteAfter && (
          <Text $fontSize="body" $marginBottom="4">{C.lockedDeleteNote(formatTrialDate(trial.deleteAfter))}</Text>
        )}
        {isOwner && <div style={{ width: "100%" }}><Subscriptions /></div>}
        {logout && <a href="/" onClick={(e) => { e.preventDefault(); logout() }}>Logout</a>}
      </Card>
    </Wrapper>
  )
}
